import React, { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import AdminDashboard from '../components/Dashboard/AdminDashboard';
import SidebarLayout from '../components/Layout/SidebarLayout';

const Dashboard = () => {
  const { authData } = useContext(AuthContext);
  return (
    <SidebarLayout>
    <div>
      {authData?.role === 'admin' ? <AdminDashboard /> : <p>Unauthorized</p>}
    </div>
    </SidebarLayout>
  );
};

export default Dashboard;
